import React, { useState } from "react";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import * as classes from "./flowStepSingleSelect.module.scss";
import SubmitButton from "@components/ui/submitButton";

const Option = ({ img, value, label, subline, onSelected, deactivated, isSelected }) => {
  const onClick = () => {
    if (!deactivated) {
      onSelected(value);
    }
  };

  const cx = classNames(classes.item, {
    [classes.selected]: isSelected,
    [classes.deactivated]: !isSelected && deactivated,
  });

  return (
    <div className={cx} onClick={onClick}>
      <div className={classes.imgCtn}>{img}</div>
      <span className={classes.title}>{label}</span>
      {subline && <span className={classes.subline}>{subline}</span>}
    </div>
  );
};

export default function FlowStepSingleSelect({ onValueSelected, options, buttonLabel }) {
  const { handleSubmit } = useForm();
  const [deactivated, setDeactivated] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const onSelected = (value) => {
    setSelectedValue(selectedValue === value ? null : value);
  };

  const onSubmit = () => {
    if (selectedValue) {
      setDeactivated(true);
      setTimeout(() => {
        onValueSelected(selectedValue);
      }, 500);
    }
  };

  const optionElements = options.map((o) => {
    return (
      <Option
        img={o.img}
        value={o.value}
        label={o.label}
        subline={o.subline}
        key={"option-" + o.value}
        onSelected={onSelected}
        deactivated={deactivated}
        isSelected={selectedValue === o.value}
      />
    );
  });

  return (
    <div className={classes.container}>
      {optionElements}
      <form onSubmit={handleSubmit(onSubmit)}>
        <SubmitButton
          tabIndex={2}
          className={classNames(classes.btn, selectedValue && "enabled")}
          disabled={!selectedValue}
        >
          {buttonLabel || "Continue"}
        </SubmitButton>
      </form>
    </div>
  );
}
